import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DesignSystemProvider } from '@lpr/ui';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <DesignSystemProvider config={{
        googlePlacesApiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
      }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </DesignSystemProvider>
    </QueryClientProvider>
  </StrictMode>
);
